// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"223":"85fa562d","879":"c649b9f2"}[chunkId] + ".chunk.js");